export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-[#050505] pt-20 pb-8 w-full overflow-hidden border-t border-yellow-700/20">
      {/* Watermark */}
      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center pointer-events-none select-none overflow-hidden h-32">
        <span className="text-[8vw] font-bold uppercase text-[#0a0a0a] tracking-widest whitespace-nowrap leading-none">
          THE ROYAL COLLISION CENTRE
        </span>
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/ec66d0a10826ab7a25aab03ee5f0d5e7/0301b63c807ec203f7bc405cc6d9f185.png"
              alt="The Royal Collision Centre"
              className="h-28 w-auto object-contain mb-5"
            />
            <p className="text-white/40 text-sm leading-relaxed font-light mb-6">
              Luxury automotive restoration perfected. Serving Escondido, California and surrounding areas.
            </p>
            <button
              onClick={() => scrollTo('contact')}
              className="whitespace-nowrap px-6 py-3 text-xs tracking-widest uppercase text-yellow-300 bg-gradient-to-r from-purple-800 to-black border border-yellow-600/40 rounded-full hover:border-yellow-500 hover:from-purple-700 transition-all duration-300 cursor-pointer"
            >
              Get Estimate
            </button>
          </div>

          {/* Col 2: Quick Links */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-6">Quick Links</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', id: 'home' },
                { label: 'Services', id: 'services' },
                { label: 'Certifications', id: 'certifications' },
                { label: 'About Us', id: 'about' },
                { label: 'Reviews', id: 'reviews' },
                { label: 'Contact', id: 'contact' },
              ].map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="whitespace-nowrap text-white/40 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer tracking-wide"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-6">Our Services</h4>
            <ul className="flex flex-col gap-3">
              {[
                'Auto Body Repair',
                'Paint & Color Matching',
                'Frame & Structural Repair',
                'Dent & Bumper Repair',
                'Auto Glass',
                'Auto Detailing',
                'Insurance Claims',
              ].map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollTo('services')}
                    className="whitespace-nowrap text-white/40 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer tracking-wide text-left"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Connect */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-6">Stay Connected</h4>
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              Follow us for showcase work, updates, and behind-the-scenes excellence.
            </p>
            <a
              href="https://www.instagram.com/theroyalcollisioncentre/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-3 text-white/60 hover:text-yellow-400 transition-colors duration-300 cursor-pointer mb-6"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-yellow-700/40 bg-yellow-900/10">
                <i className="ri-instagram-line text-yellow-500 text-lg"></i>
              </div>
              <span className="text-sm tracking-wide">@theroyalcollisioncentre</span>
            </a>

            <div className="flex flex-col gap-2 text-white/40 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-yellow-700/60 text-sm"></i>
                <a href="tel:7606664151" className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer">(760) 666-4151</a>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-yellow-700/60 text-sm"></i>
                <span>Mon–Fri 7AM–5PM</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-yellow-700/60 text-sm mt-0.5"></i>
                <span>2127 E Valley Pkwy,<br />Escondido, CA 92027</span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-yellow-700/30 to-transparent mb-8"></div>

        {/* Copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-white/25 text-xs tracking-widest uppercase">
          <span>&copy; 2025 The Royal Collision Centre. All rights reserved.</span>
          <span>Escondido, California</span>
        </div>
      </div>
    </footer>
  );
}
